export default __webpack_public_path__ + "logo58c89f3.png";